class LocaleContainer {

  protected defaultLocale: string = "nl-NL";
  protected locales: Array<{value: string, translationKey: string}> = [
    {
      value: "nl-NL",
      translationKey: "locale-nl-nl"
    },
    {
      value: "en-US",
      translationKey: "locale-en-us"
    },
    {
      value: "en-CY",
      translationKey: "locale-en-cy"
    }
  ];

  public all(): Array<{value: string, translationKey: string}> {
    return this.locales;
  }
}

export default new LocaleContainer();
